import { get } from './common';

export type LaxhjalpenStudentRegistrationValidation = {
	ssnRegex: string | null;
};

export function getStudentRegistrationValidation() {
	return get<LaxhjalpenStudentRegistrationValidation>('api/laxhjalpenregistration/GetStudentRegistrationValidation');
}
